import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

function TreinadoresNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/7b22204017c50d4f304e554e533f6383.jpeg"
                alt="AAPEQ"
                className="h-12 w-auto"
              />
            </Link>
          </div>

          <div className="hidden sm:flex items-center gap-6">
            <button
              onClick={() => navigate(-1)}
              className={`flex items-center gap-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer bg-transparent border-none ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              <i className="ri-arrow-left-line text-base"></i>
              Voltar
            </button>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Treinadores+%E2%80%94+menu+superior+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#F05954] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#d94943] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Entrar na AAPEQ
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="sm:hidden p-2 cursor-pointer"
          >
            <i
              className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
                isScrolled ? 'text-[#262364]' : 'text-white'
              }`}
            ></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="sm:hidden bg-white border-t border-gray-100 py-4">
            <div className="flex flex-col space-y-3 px-4">
              <button
                onClick={() => { setIsMobileMenuOpen(false); navigate(-1); }}
                className="flex items-center gap-2 text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
              <a
                href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Treinadores+%E2%80%94+menu+mobile+%E2%80%94+Quero+entrar+na+AAPEQ"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F05954] text-white px-5 py-3 rounded-full text-sm font-medium text-center hover:bg-[#d94943] transition-all cursor-pointer block"
              >
                Entrar na AAPEQ
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default function TreinadoresPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const objetivos = [
    'Conduzir pessoas com presença, clareza e autoridade vibratória',
    'Ampliar sua energia pessoal e projeção profissional',
    'Lidar com grupos, turmas e atendimentos com equilíbrio emocional',
    'Reforçar liderança natural, magnetismo e foco',
    'Melhorar a capacidade de orientar pessoas com precisão',
    'Dominar o próprio campo energético sem se desgastar',
    'Acesso ao estado zero para direção e decisões',
    'Atualizar sua leitura emocional, comportamental e energética de alunos e clientes'
  ];

  const paraQuem = [
    { title: 'Professores (todas as áreas)', items: ['Artes', 'Educação Física', 'Dança', 'Teatro', 'Música', 'Ensino médio / fundamental', 'Preparadores, instrutores, educadores'] },
    { title: 'Treinadores', items: ['Treinador físico', 'Treinador mental', 'Treinador artístico', 'Treinador cênico', 'Treinador vocal', 'Treinador de performance'] },
    { title: 'Coaches', items: ['Coach de vida', 'Coach comportamental', 'Coach de performance', 'Coach emocional', 'Coach de alta performance', 'Coach vocacional', 'Coach artístico'] },
    { title: 'Líderes e condutores de grupos', items: ['Instrutores', 'Facilitadores', 'Mentores', 'Coordenadores de projetos', 'Diretores de equipes', 'Monitores e orientadores'] }
  ];

  const comprovacao = [
    'Vídeo dando aula ou conduzindo sessão',
    'Foto em turma, palco, sala de aula, estúdio',
    'Certificado de curso ou formação que já ministra',
    'Site profissional ou página de rede social',
    'Declaração da instituição onde ensina',
    'Perfil profissional ativo (coach, professor, treinador)'
  ];

  const resultados = [
    'Presença e autoridade vibratória muito mais forte',
    'Comunicação mais clara, firme e segura',
    'Capacidade de influenciar grupos com mais equilíbrio',
    'Leitura emocional e comportamental avançada',
    'Domínio da própria energia durante atendimentos',
    'Foco extremo e direcionamento assertivo',
    'Confiança ampliada ao conduzir equipes, turmas ou clientes',
    'Estabilidade emocional em situações de conflito',
    'Condução profissional com menos desgaste e mais precisão'
  ];

  const tecnicas = [
    { title: 'Energia & Liderança', items: ['Blindagem energética do treinador', 'Aumento da presença pessoal', 'Direcionamento vibratório do grupo', 'Leitura instantânea de quedas emocionais'] },
    { title: 'Telepatia Aplicada', items: ['Leitura sutil de comportamento', 'Comunicação vibratória com alunos e clientes', 'Alinhamento coletivo em segundos', 'Entendimento da energia do ambiente'] },
    { title: 'Alta Performance Emocional', items: ['Estado zero', 'Ação perfeita', 'Respiração de foco', 'Controle de ansiedade', 'Estabilidade em momentos críticos'] },
    { title: 'Comunicação Consciente', items: ['Palavra que direciona sem destruir', 'Linguagem firme, clara e ativa', 'Capacidade de guiar alunos com precisão'] },
    { title: 'Psicologia da Condução', items: ['Entender o que bloqueia o aluno', 'Desconstrução e reconstrução saudável', 'Ajuste de crenças e medos durante processos', 'Postura emocional de liderança'] }
  ];

  const pratica = [
    'Direcionar energia do grupo',
    'Conduzir atendimentos com força e equilíbrio',
    'Criar ambientes energéticos positivos para treinamentos',
    'Ajustar atmosferas emocionais antes de aulas e sessões',
    'Se proteger emocional e energeticamente',
    'Evitar sobrecarga e desgaste interno',
    'Manter foco durante longas conduções',
    'Criar logísticas emocionais para aulas e sessões',
    'Ser uma referência de liderança para alunos e clientes'
  ];

  const transformacao = [
    'Conduz com muito mais força, presença e energia',
    'Lidera com clareza e autoridade',
    'Se torna emocionalmente equilibrado',
    'Enxerga as necessidades internas de cada aluno',
    'Lê comportamentos com precisão',
    'Cria grupos fortes e disciplinados',
    'Não absorve energias negativas durante atendimentos',
    'Se torna referência profissional em sua área',
    'Atua com mentalidade de alta performance'
  ];

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <TreinadoresNavbar />

      {/* Banner */}
      <div className="relative w-full h-[260px] sm:h-[300px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/6033e34f0d4f6ed44bd296e254a2945e.jpg"
          alt="Treinadores, Professores e Coaches — AAPEQ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center px-5 text-center">
          <div className="inline-block bg-[#F05954] text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            Liderança e Condução
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight">
            Treinadores, Professores e Coaches
          </h1>
          <p className="text-sm sm:text-base text-white/80 mt-3 max-w-xl">
            A formação que expande a liderança, a energia e a capacidade de conduzir pessoas
          </p>
        </div>
      </div>

      <div className="max-w-screen-xl mx-auto">

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              A aba AAPEQ para treinadores, professores e coaches é destinada a todos os profissionais que atuam conduzindo pessoas, seja no campo artístico, físico, emocional, educacional ou comportamental.
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              Essa formação eleva liderança, energia, foco, presença, psicologia aplicada e condução profissional.
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-target-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Objetivo da Formação</h2>
            </div>
            <p className="text-base text-gray-700 font-semibold mb-6">Desenvolver um líder capaz de:</p>
            <div className="grid sm:grid-cols-2 gap-3">
              {objetivos.map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <p className="text-base text-gray-700 font-semibold mt-6">
              O profissional passa a conduzir com mais força, estratégia, consciência e equilíbrio.
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-team-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Para Quem é Esta Formação</h2>
            </div>
            <p className="text-base text-gray-700 mb-6">Esta formação é destinada a profissionais que trabalham com pessoas, tais como:</p>
            <div className="space-y-6">
              {paraQuem.map((categoria, index) => (
                <div key={index} className="bg-gray-50 p-5 rounded-xl">
                  <h3 className="text-base font-bold text-[#262364] mb-3 flex items-center gap-2">
                    <span className="text-[#F05954]">✔</span>
                    {categoria.title}
                  </h3>
                  <div className="grid sm:grid-cols-2 gap-2 pl-5">
                    {categoria.items.map((item, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                        <span className="text-sm text-gray-700">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-bookmark-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Exigência para Entrar</h2>
            </div>
            <p className="text-base text-gray-700 font-semibold mb-4">
              O profissional deve atuar comprovadamente com pessoas, seja ensinando, conduzindo, treinando ou mentorando.
            </p>
            <p className="text-base text-gray-700 mb-4">Aceitamos como comprovação:</p>
            <div className="space-y-3 mb-6">
              {comprovacao.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-[#F05954] text-white p-5 sm:p-6 rounded-xl">
              <p className="text-base font-semibold">AAPEQ é exclusivamente para atuantes.</p>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-fire-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Resultados Práticos</h2>
            </div>
            <p className="text-base text-gray-700 mb-6">Após passar pela AAPEQ, o profissional desenvolve:</p>
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {resultados.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5">✔</span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-[#262364] text-white p-5 sm:p-6 rounded-xl">
              <p className="text-base font-semibold mb-1">O treinador AAPEQ não é "apenas um instrutor".</p>
              <p className="text-base">Ele se torna um campo de liderança ativa.</p>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-tools-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Processos e Técnicas Exclusivas da AAPEQ</h2>
            </div>
            <div className="space-y-4">
              {tecnicas.map((tecnica, index) => (
                <div key={index} className="bg-white p-5 rounded-xl border-l-4 border-[#F05954]">
                  <h3 className="text-base font-bold text-[#262364] mb-3 flex items-start gap-2">
                    <span className="text-[#F05954] flex-shrink-0">✔</span>
                    {tecnica.title}
                  </h3>
                  <div className="grid sm:grid-cols-2 gap-2 pl-5">
                    {tecnica.items.map((item, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                        <span className="text-sm text-gray-700">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-lightbulb-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">O Que o Treinador Aprende na Prática</h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              {pratica.map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                  <span className="w-2 h-2 rounded-full bg-[#262364] flex-shrink-0 mt-2"></span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-trophy-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Transformação Final do Profissional AAPEQ</h2>
            </div>
            <p className="text-base text-gray-700 mb-6">
              O treinador/professor/coach que passa por essa formação torna-se alguém que:
            </p>
            <div className="grid sm:grid-cols-2 gap-3">
              {transformacao.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5">✔</span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 sm:py-20 px-5 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl font-black text-[#262364] mb-6">
              Quer expandir sua liderança e capacidade de conduzir pessoas?
            </h2>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Treinadores+%E2%80%94+CTA+final+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full sm:w-auto bg-[#F05954] text-white px-6 py-4 rounded-full text-base font-semibold hover:bg-[#262364] transition-all cursor-pointer mx-4 sm:mx-0"
            >
              Entrar na AAPEQ — Treinadores
            </a>
            <div className="mt-8">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#262364] transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
